import CIMDataExportPage from './CIMDataExportPage';

export default CIMDataExportPage;
